














































































































import { EventResponse } from '@/model/Event';
import { Sheet } from '@/model/Sheet';
import { Component, Emit, Prop } from 'vue-property-decorator';
import CardInnerLayout from '@/components/layout/CardInnerLayout.vue';
import EventIcon from '@/components/event/EventIcon.vue';
import { dateFormatOptions } from '@/lib/date-util';
import CustomModal from '@/components/modal/CustomModal.vue';
import CreateEventModal from '@/active-components/dashboard/CreateEventModal.vue';
import ConfirmationModal from '@/components/modal/ConfirmationModal.vue';
import ToastMixin from '@/mixins/ToastMixin';
import { mixins } from 'vue-class-component';
import ToastVariant from '@/model/enums/toast/toast-variant';

@Component({
    components: {
        CardInnerLayout,
        EventIcon,
        CustomModal,
        CreateEventModal,
        ConfirmationModal,
    },
})
export default class DashboardCard extends mixins(ToastMixin) {
    @Prop() item!: Sheet | EventResponse;

    @Prop({ type: Boolean }) icons!: boolean;

    @Emit()
    onClick(): void {
        this.showToast(
            this.$t(
                'dashboard.events.notification.successful-update',
            ).toString(),
            this.$t('dashboard.events.notification.title').toString(),
            ToastVariant.SUCCESS,
        );
        this.$bvModal.hide(`update-modal-${this.item.id}`);
    }

    @Emit()
    deleteEvent(): void {
        // delete event
    }

    formatDate(date: Date): string {
        return date?.toLocaleDateString(this.$i18n.locale, dateFormatOptions);
    }

    onClose(item: EventResponse): void {
        this.$bvModal.hide(`update-modal-${item.id}`);
    }
}
